#import "~/graphql/fragments/assets/defaultImageAsset.graphql"

fragment socialFragment on Ether_SeoData {
    title
    description
    social {
        twitter {
            title
            description
            image {
                ... DefaultImageAsset
            }
        }
        facebook {
            title
            description
            image {
                ... DefaultImageAsset
            }
        }
    }
    advanced {
        robots
        canonical
    }
}
